import { useEffect, useState } from 'react';

import { EcoRebatesApiError } from '../errors/EcoRebatesApiError';
import { getEcoRebatesUrl } from '../utils/get-ecorebates-url';

export const useEcoRebatesApi = ({
  consumerType,
  filterData,
  pageNumber,
  pageSize,
  zipCode
}) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMethod = async () => {
      setLoading(true);

      const url = getEcoRebatesUrl({
        consumerType,
        filterData,
        pageNumber,
        pageSize,
        zipCode
      });

      try {
        const response = await window.fetch(url);

        if (!response.ok) {
          throw new EcoRebatesApiError(response);
        }

        const responseData = await response.json();
        setData(responseData.EcoRebatesResponse);
        setLoading(false);
      } catch (error) {
        // TODO: NR/Analytics Reporting
        LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rebate-center.page-load-error', error?.response);
      } finally {
        LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rebate-listings.ready');
      }
    };

    fetchMethod();
  }, [
    consumerType,
    filterData,
    pageNumber,
    pageSize,
    zipCode,
  ]);

  return { data, loading };
};
